import React from 'react';
import { FaWindows } from 'react-icons/fa';
import { FileSelect } from './file-select.component.component';
import { ButtonContainer } from './button-container.component';
import { useTranslation } from 'react-i18next';

export const FileLoad = () => {
  const { t } = useTranslation();

  return (
    <div>
      <div className="font-mono text-[9.5px] tracking-[0.14em] uppercase text-content-muted-light mb-[13px]">
        {t('management.download')}
      </div>
      <FileSelect />

      {/* The Unreal plugin is a separate artifact from the Maya toolset above —
          built per engine version, served from its own slot — but it ships to
          TouchPose owners rather than being sold on its own, so it sits here
          instead of getting a product card. */}
      <div className="mt-[20px]">
        <div className="font-mono text-[9.5px] tracking-[0.14em] uppercase text-content-muted-light mb-[13px]">
          {t('management.unrealDownload')}
        </div>
        {/* The mac slot is declared in the release registry and package.json,
            but its zip cannot be cross-compiled — it has to come off the macOS
            runner. A button for an unstaged slot 404s while still toasting
            "download started", so macOS appears here once that zip lands. */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-[10px]">
          <ButtonContainer os="win64" product="touchpose-unreal" label="Windows">
            <FaWindows size={18} color="var(--color-text-muted-alt)" />
          </ButtonContainer>
        </div>
        <p className="mt-[10px] font-body italic text-[12px] text-content-muted-alt leading-[1.5]">
          {t('management.unrealNote')}
        </p>
      </div>

      <a
        href="https://github.com/squarebit-studios/touchpose-public/releases"
        target="_blank"
        rel="noopener noreferrer"
        className="inline-flex items-center gap-[5px] mt-[10px] py-[4px] font-body text-[12px] text-content-muted-alt hover:text-blue transition-colors cursor-pointer"
      >
        <span>🗂</span>
        <span>{t('management.browseVersions')}</span>
      </a>
    </div>
  );
};
